import BaseSetup from '@/components/BaseSetup';
import type OrganizationCompanyListItemEntity from '@/entity/organization-company/OrganizationCompanyListItemEntity';
import { useCompanyService } from '@/services/company/CompanyService';
import { Reactive } from '@/utils/decorators';
import { useNotif } from '@orion.ui/orion';
import { ref } from 'vue';

export type SharedLogoCompanyModalEmits = {};
export type SharedLogoCompanyModalProps = {
	companyId: number
	companyLogoId?: number
	companyEntity?: OrganizationCompanyListItemEntity
};

export default class SharedLogoCompanyModalSetup extends BaseSetup {

	static readonly defaultProps = {};

	readonly _cropper = ref<OrionCropper>();
	@Reactive private readonly state = { files: [] as File[] };

	get files () { return this.state.files }
	get selectedFile () { return this.state.files[0] }

	constructor (
		private props: SharedLogoCompanyModalProps,
		private emits: SharedLogoCompanyModalEmits,
		private _modal?: OrionModal,
	) {
		super();
	}

	async uploadAsync () {
		if (!this.files || !this.files[0]) {
			useNotif.warning(this.$t('business.pleaseSelectFile'));
			return;
		}

		this._modal?._loader()?.show(this.$t('business.savingNewLogo'));

		if (this.props.companyLogoId) {
			await useCompanyService(this.props.companyEntity).updateLogoAsync({
				file: this.files[0],
				id: this.props.companyLogoId,
			});
		}
		else {
			await useCompanyService(this.props.companyEntity).addLogoAsync({
				file: this.files[0],
				companyId: this.props.companyId,
			});
		}

		this._modal?._loader()?.hide();
		this._modal?.close();
		useNotif.success(this.$t('common.modificationSaved'), this.$t('business.logoModifiedSuccessfully'));
	}

	async deleteAsync () {
		if (!this.props.companyLogoId) return;
		this._modal?._loader()?.show(this.$t('business.deletingLogo'));

		try {
			await useCompanyService(this.props.companyEntity).deleteLogoAsync(this.props.companyLogoId);
			useNotif.success(this.$t('common.modificationSaved'), this.$t('business.logoDeletedSuccessfully'));
			this._modal?.close();
		}
		catch (e: any) {
			useNotif.danger(this.$t('common.notification.oops'), e?.response?.data);
		}
		finally {
			this._modal?._loader()?.hide();
		}
	}

}
